import React from "react";

//COMPONENTS
import { HeaderLaptop, HeaderMobile } from "../components/Header";
import Cta from "../components/Cta";
import ServiceContent from "../components/ServiceContent";
//ASSETS
import PayrollImage from "../assets/payroll-header.svg";
import PRImg1 from "../assets/payroll-1.svg";
import PRImg2 from "../assets/payroll-2.svg";
import PRImg3 from "../assets/payroll-3.svg";
import PRImg4 from "../assets/payroll-4.svg";

const content = [
  {
    title:
      "Outsourced Payroll solutions to suit your business, our services include:",
    text: (
      <ul>
        <li>• Customised payslips</li>
        <li>
          • Administration of PAYE, national insurance, statutory sick pay,
          statutory maternity pay, etc
        </li>
        <li>
          • Completion of weekly/monthly statutory forms to submit to HM Revenue
          & Customs under the new Real Time Information regime
        </li>
        <li>• Construction Industry Scheme (CIS) returns</li>
        <li>• Summaries and analyses of staff costs</li>
        <li>
          • Administration of incentive schemes, bonuses and termination
          payments
        </li>
        <li>• Administration of pension schemes</li>
        <li>• Auto Enrolment</li>
      </ul>
    ),
    img: PRImg1,
  },
  {
    title: "Outsourced Payroll solutions to suit your business",
    text: (
      <ul>
        <li>
          • Process your payroll, accurately and on time Bespoke Reports,
          providing accurate information
        </li>
        <li>
          • Workplace Pensions calculated accurately and sent to your pension
          provider
        </li>
        <li>• Manage your payroll with a simple, cost-effective service</li>
        <li>
          • You can also benefit from the branding of your payslips and reports
        </li>
      </ul>
    ),
    img: PRImg2,
  },
  {
    text: (
      <div>
        <p>Salaried staff, shift working, variable hours, temporary staff, zero hours, additional 
          payments, sign off processes it’s all covered as part of our payroll outsourcing service.</p>
        <p>Going for an outsourced payroll service allows you to run your payroll, with various 
          payment rates and working patterns, for a mixture of salaried, full time, part time and 
          zero hours’ contracts and our Auto-enrolment service, covers the whole process from start 
          to finish.</p>
      </div>
    )
  },
  {
    title: "Key Benefits of Our Payroll Outsourcing Services",
    text: (
      <ul>
        <li>• Free up the time you spend on payroll tasks</li>
        <li>• Manage your payroll costs</li>
        <li>• A Payroll Specialist assigned to work with you</li>
        <li>• Auto Enrolment as an end to end service</li>
        <li>• Good communication</li>
        <li>• Peace of mind your payroll is looked after</li>
      </ul>
    ),
    img: PRImg3,
  },
  {
    title: "A payroll solution built for purpose",
    text: "Whether you are looking to switch from another Payroll solution or you are new to contracting , you’ll enjoy an unbeatable service provided by our team of experts when you partner with Nectar 1 Consulting & Payroll."
  },
  {
    title: "Ours BACS Payment Service",
    text: (
      <p>
        Each and every organisation needs to have confidence in its wage’s payment service, 
        with an efficient and robust mechanism for safeguarding the transfer of funds, while 
        ensuring funds are paid accurately and on time.
        <br/>
        We ensure payments to your employees are prompt and accurate and we apply meticulous 
        attention to detail to every aspect of your service.
        <br/>
        Our specialist BACS-approved bureau provides extensive payments reporting, providing 
        an essential service which fulfils our clients’ needs and the cost is more than competitive.
      </p>
    ),
    img: PRImg4,
  },
  {
    title: "CIS: Construction Industry Scheme",
    text: (
      <p>
        Nectar Consulting CIS is for self-employed construction workers that are registered 
        under the Construction Industry Scheme (CIS). By joining Nectar CIS, we’ll guide you, 
        with our expert support.
        <br/>
        We’ll get your money to you as fast and pain-free as possible. We do this by handling 
        all the unnecessary admin, invoicing your Agency/ end client and paying your CIS tax 
        deductions to HMRC. With Nectar CIS, we will make sure that you are compliant with HMRC 
        and we also provide comprehensive insurance cover. Our specialists will always be on hand 
        to talk if you have any queries or concerns.
      </p>
    )
  },
];

const Payroll = () => {
  return (
    <div>
      <HeaderLaptop
        titlePart1="Payroll"
        titlePart2=""
        pageSnippet="Payroll should be something you don’t need to think about. You just need your staff to be paid the right amount every time. We have designed our processes to guarantee that."
        headerIllustration={PayrollImage}
        alt="Payroll"
      />
      <HeaderMobile
        titlePart1="Payroll"
        titlePart2=""
        pageSnippet="Payroll should be something you don’t need to think about. You just need your staff to be paid the right amount every time. We have designed our processes to guarantee that."
        headerIllustration={PayrollImage}
        alt="Payroll"
      />

      <div className="max-w-7xl mx-auto px-4 my-16 sm:px-6 lg:my-32">
        <h2 className="header2 text-center">
          Enjoy an<span className="text-earth"> unbeatable</span> service
        </h2>
        <p className="text-center mt-8">
          Providing our clients with the most reliable, affordable, hassle-free solution to running 
          your Payroll, HR, and BACS/Wages payments possible. We’ll make sure your employees are paid 
          accurately and on time, every time. Our Payroll solutions are fast, efficient and require 
          minimal input by you. We cater to all business sizes and scale to fit with your particular 
          business needs.
        </p>
        {content.map((item, index) => (
          <ServiceContent
            key={item.index}
            isLast={index === content.length - 1}
            title={item.title}
            img={item.img}
            alt={item.alt}
            text={item.text}
            isLeftAlign={index % 2}
          />
        ))}
      </div>

      <Cta />
    </div>
  );
};

export default Payroll;
